
(function() {
  'use strict';

  /* ── PRODUCT IMAGE CACHE (same as collection page) ── */
  var _productCache = {};

  function getProductData(handle) {
    return new Promise(function(resolve, reject) {
      if (_productCache[handle]) { resolve(_productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(d) { _productCache[handle] = d; resolve(d); })
        .catch(reject);
    });
  }

  function swapProductImage(card, src) {
    var img = card.querySelector('.bsale-product-img');
    if (!img || !src) return;
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.2s ease';
    setTimeout(function() {
      img.removeAttribute('srcset'); // must remove before setting src
      img.src = src;
      img.style.opacity = '1';
    }, 150);
  }

  /* ── SWATCH CLICK → IMAGE SWAP + VARIANT UPDATE ── */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.shade-btn[data-variant-id]');
    if (!swatch) return;

    var card = swatch.closest('.bsale-card');
    if (!card) return;

    // Update active state across all swatches in this picker
    var picker = swatch.closest('.shade-picker, .bsale-swatches');
    if (picker) {
      picker.querySelectorAll('.shade-btn').forEach(function(b) {
        b.classList.remove('shade-active');
        b.setAttribute('aria-pressed', 'false');
        b.style.background = 'transparent';
        b.style.borderColor = 'rgba(27,46,94,0.3)';
        b.style.color = '#5A7090';
      });
    }
    swatch.classList.add('shade-active');
    swatch.setAttribute('aria-pressed', 'true');
    swatch.style.background = '#F0E8D8';
    swatch.style.borderColor = '#1B2E5E';
    swatch.style.color = '#1B2E5E';

    // Announce shade selection to screen readers
    var shadeLabel = swatch.getAttribute('aria-label') || swatch.textContent.trim();
    announceToSR('Shade selected: ' + shadeLabel);

    var variantId = swatch.getAttribute('data-variant-id');

    // Update ATC button with new variant ID
    var atcBtn = card.querySelector('.bsale-atc');
    if (atcBtn && variantId) {
      atcBtn.setAttribute('data-vid', variantId);
      card.setAttribute('data-selected-variant', variantId);
    }

    // Image swap - check cached data-variant-image first
    var cachedImg = swatch.getAttribute('data-variant-image');
    if (cachedImg && cachedImg !== '') {
      swapProductImage(card, cachedImg);
      return;
    }

    // No cached image - fetch from /products/handle.js (same as collection page)
    var handle = card.getAttribute('data-product-handle');
    if (!handle) return;

    getProductData(handle).then(function(data) {
      var imgSrc = null;
      var vid = variantId ? parseInt(variantId, 10) : null;

      // Strategy 1: variant's assigned featured_image
      if (vid && data.variants) {
        for (var v = 0; v < data.variants.length; v++) {
          if (data.variants[v].id === vid && data.variants[v].featured_image) {
            imgSrc = data.variants[v].featured_image.src;
            break;
          }
        }
      }

      // Strategy 2: index-based image fallback
      if (!imgSrc && data.images && data.images.length > 1) {
        var variantIndex = 0;
        if (vid && data.variants) {
          for (var vi = 0; vi < data.variants.length; vi++) {
            if (data.variants[vi].id === vid) { variantIndex = vi; break; }
          }
        }
        imgSrc = data.images[variantIndex % data.images.length];
      }

      if (imgSrc) {
        if (imgSrc.indexOf('?') === -1) imgSrc += '?width=600';
        swatch.setAttribute('data-variant-image', imgSrc);
        swapProductImage(card, imgSrc);
      }
    }).catch(function() {});
  });

  /* ── ADD TO CART ── */
  function openCartDrawer() {
    if (window.BWCart && typeof window.BWCart.refresh === 'function') {
      window.BWCart.refresh(true); // refresh cart + open drawer
    } else if (window.BWCart && typeof window.BWCart.open === 'function') {
      window.BWCart.open();
    }
  }

  /* Shared live region - screen readers announce state changes */
  var _bsaleLiveEl = null;
  function _bsaleLive() {
    if (!_bsaleLiveEl) {
      _bsaleLiveEl = document.getElementById('bsale-live-region');
      if (!_bsaleLiveEl) {
        _bsaleLiveEl = document.createElement('div');
        _bsaleLiveEl.id = 'bsale-live-region';
        _bsaleLiveEl.setAttribute('role', 'status');
        _bsaleLiveEl.setAttribute('aria-live', 'polite');
        _bsaleLiveEl.setAttribute('aria-atomic', 'true');
        _bsaleLiveEl.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
        document.body.appendChild(_bsaleLiveEl);
      }
    }
    return _bsaleLiveEl;
  }
  function announceToSR(msg) {
    var el = _bsaleLive();
    el.textContent = '';
    setTimeout(function() { el.textContent = msg; }, 50);
  }

  function setAtcState(btn, state) {
    var lbl  = btn.querySelector('.atc-label');
    var load = btn.querySelector('.atc-loading');
    btn.disabled = (state === 'loading');
    btn.setAttribute('aria-busy', (state === 'loading').toString());
    if (lbl)  lbl.style.display  = (state === 'loading') ? 'none' : '';
    if (load) load.style.display = (state === 'loading') ? '' : 'none';
    if (state === 'loading') {
      announceToSR('Adding item to cart');
    }
    if (state === 'done' && lbl) {
      lbl.textContent = 'ADDED!';
      announceToSR('Item added to cart successfully');
      setTimeout(function() { lbl.textContent = btn.getAttribute('data-default-label') || 'ADD TO CART'; }, 2000);
    }
    if (state === 'error' && lbl) {
      lbl.textContent = 'TRY AGAIN';
      announceToSR('Could not add to cart. Please try again.');
      setTimeout(function() { lbl.textContent = btn.getAttribute('data-default-label') || 'ADD TO CART'; }, 2500);
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.bsale-atc');
    if (!btn) return;

    var vid = btn.getAttribute('data-vid');
    if (!vid || vid === '' || vid === 'undefined') {
      // Try getting from the card's data-selected-variant
      var card = btn.closest('.bsale-card');
      if (card) vid = card.getAttribute('data-selected-variant');
    }
    if (!vid || vid === '' || vid === 'undefined') {
      console.warn('[BroGlo ATC] No variant ID - assign a product in Theme Editor');
      return;
    }

    setAtcState(btn, 'loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || ('Error ' + r.status)); });
      return r.json();
    })
    .then(function() {
      setAtcState(btn, 'done');
      setTimeout(openCartDrawer, 300);
    })
    .catch(function(err) {
      console.error('[BroGlo ATC]', err.message || err);
      setAtcState(btn, 'error');
    });
  });

  /* ── SMOOTH SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── MARQUEE PAUSE ── */
  document.querySelectorAll('.marquee-track').forEach(function(track) {
    track.addEventListener('mouseenter',  function() { track.classList.add('paused'); });
    track.addEventListener('mouseleave',  function() { track.classList.remove('paused'); });
    track.addEventListener('touchstart',  function() { track.classList.add('paused'); }, { passive: true });
    track.addEventListener('touchend',    function() { track.classList.remove('paused'); }, { passive: true });
  });

  /* ── SCROLL REVEAL ── */
  var revealEls = document.querySelectorAll('.reveal, .reveal-left');
  if (revealEls.length) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealEls.forEach(function(el) { el.classList.add('visible'); });
    } else {
      setTimeout(function() {
        revealEls.forEach(function(el) { el.classList.add('visible'); });
      }, 800);
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
        revealEls.forEach(function(el) { io.observe(el); });
      }
    }
  }

})();
